<template>
  <div :class="b()">
    <div :class="b('group')" v-if="isDategroup">
      <div :class="b('radio')">
        <el-radio-group :size="size" @change="handleChange" v-model="text">
          <el-radio-button :label="item.value" v-for="(item, index) in menu" :key="index">{{ item.label }}</el-radio-button>
        </el-radio-group>
      </div>
      <div :class="b('date')">
        <el-date-picker
          v-model="datetime"
          type="daterange"
          :size="size"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          @focus="handleFocus"
          @change="handleChange"
          :range-separator="$lang('至')"
          :start-placeholder="$lang('开始日期')"
          :end-placeholder="$lang('结束日期')"
          :editable="editable"
        ></el-date-picker>
      </div>
    </div>
    <el-date-picker
      v-else
      :type="type"
      v-model="text"
      :size="size"
      :readonly="readonly"
      :range-separator="$lang('至')"
      :start-placeholder="$lang(startPlaceholder)"
      :end-placeholder="$lang(endPlaceholder)"
      :format="format"
      :clearable="disabled ? false : clearable"
      :picker-options="pickerOptions"
      :value-format="valueFormat"
      :default-time="defaultTime"
      :placeholder="placeholder"
      :editable="editable"
      @change="handleChange"
      @blur="handleBlur"
      @focus="handleFocus"
      @click.native="handleClick"
      :disabled="disabled"
    >
    </el-date-picker>
  </div>
</template>

<script>
import create from '../../core/create'
import { GetDateStr } from '../../utils/date.js'
import props from '../../core/common/props.js'
import event from '../../core/common/event.js'
export default create({
  name: 'date',
  mixins: [props(), event()],
  data() {
    return {
      text: '',
      menu: [],
      datetime: [GetDateStr(0), GetDateStr(30)]
    }
  },
  props: {
    default: {
      type: Boolean,
      default: false
    },
    value: {},
    startPlaceholder: {
      type: String,
      default: '开始日期'
    },
    endPlaceholder: {
      type: String,
      default: '结束日期'
    },
    defaultTime: {
      type: [Array, String]
    },
    pickerOptions: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      default: 'date'
    },
    valueFormat: {
      type: String,
      default: 'yyyy-MM-dd HH:mm:ss'
    },
    format: {},
    editable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isDategroup() {
      return this.type === 'dategroup'
    }
  },
  watch: {
    datetime() {
      this.text = ''
      this.setCurrent((this.datetime || []).join(','))
    }
  },
  created() {
    if (this.isDategroup) {
      this.init()
    }
  },
  mounted() {},
  methods: {
    // handleChange(val) {
    //   this.setCurrent(val);
    // },
    setCurrent(val) {
      this.$emit('input', val)
      this.$emit('change', val)
    },
    init() {
      this.menu = [
        {
          label: this.$lang('今日'),
          value: GetDateStr(0)
        },
        {
          label: this.$lang('昨日'),
          value: GetDateStr(-1)
        },
        {
          label: this.$lang('近7天'),
          value: GetDateStr(-7)
        },
        {
          label: this.$lang('全部'),
          value: '-1'
        }
      ]
      if (this.default) {
        this.text = GetDateStr(0)
        this.setCurrent(this.text)
      }
    }
  }
})
</script>

